import StylableButton_DefaultComponent from '../components/StylableButton/viewer/skinComps/Default/Default.skin';
import StylableButton_DefaultController from '../components/StylableButton/viewer/StylableButton.controller';


const StylableButton_Default = {
  component: StylableButton_DefaultComponent,
  controller: StylableButton_DefaultController
};


export const components = {
  ['StylableButton_Default']: StylableButton_Default
};

